import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import {CameraOptions} from "@ionic-native/camera";
import {WorkReportProvider} from "../../providers/work-report/work-report";

/**
 * Generated class for the PartDetailPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-part-detail',
  templateUrl: 'part-detail.html',
})
export class PartDetailPage {

  salesOrder: any;
  part: any;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private workReportProvider: WorkReportProvider
  ) {
    this.salesOrder = this.navParams.get('salesOrder');
    this.part = this.navParams.get('part');
  }

  ionViewDidLoad() {

  }

}



// WEBPACK FOOTER //
// ./src/pages/part-detail/part-detail.ts